import React from "react";
import { FontFamily } from "../../../Constants/Enums/FontFamily.enums";
import { FONT_SIZE } from "../../../Constants/Enums/styles.enum";
import { Colors } from "../../../Constants/colors";

export const EmptyList = () => {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        padding: "80px 40px",
        minHeight: "400px",
        backgroundColor: Colors.White,
      }}
    >
      <div
        style={{
          width: "120px",
          height: "120px",
          borderRadius: "50%",
          backgroundColor: `${Colors.TangerineOrange}10`,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          marginBottom: "24px",
          animation: "pulse 2s ease-in-out infinite",
        }}
      >
        <svg
          width="60"
          height="60"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M20 6H4C2.89 6 2 6.89 2 8V19C2 20.11 2.89 21 4 21H20C21.11 21 22 20.11 22 19V8C22 6.89 21.11 6 20 6ZM20 19H4V8H20V19Z"
            fill={Colors.TangerineOrange}
            opacity="0.7"
          />
          <path
            d="M6 10H10V12H6V10ZM6 14H14V16H6V14ZM16 14H18V16H16V14Z"
            fill={Colors.TangerineOrange}
            opacity="0.5"
          />
        </svg>
      </div>
      <h3
        style={{
          fontFamily: FontFamily.POPPINS_BOLD,
          fontSize: "20px",
          color: Colors.Black,
          marginBottom: "8px",
          fontWeight: 600,
        }}
      >
        No Data Available
      </h3>
      <p
        style={{
          fontFamily: FontFamily.ROBOTO_REGULAR,
          fontSize: FONT_SIZE.F14,
          color: Colors.Grey,
          textAlign: "center",
          maxWidth: "400px",
          lineHeight: "1.6",
        }}
      >
        There are no records to display at the moment. Data will appear here
        once available.
      </p>
      <style>
        {`
            @keyframes pulse {
                0%, 100% {
                    transform: scale(1);
                        opacity: 1;
                    }
                50% {
                    transform: scale(1.05);
                        opacity: 0.8;
                    }
                }
            `}
      </style>
    </div>
  );
};
